import http from '@/plugins/http';
import reportError from '@/utils/reportError';

// When the request succeeds
const success = (response, successCallback) => {
  successCallback(response);
};

// When the request fails
const failed = () => {
};

export default (job, score, comment, successCallback, token, fromUserId) => {
  const feedback = {};
  feedback.score = score;
  feedback.feedback = comment;
  const params = { feedback };
  if (token) {
    params.token = token;
  }

  if (fromUserId) {
    params.fromUserId = fromUserId;
  }
  http.post(`/customer/me/jobs/${job.id}/feedback`, params)
    .then((response) => {
      success(response.data, successCallback);
    })
    .catch((error) => {
      reportError(error, 'error trying to get job feedback');
      failed(error);
    });
};
